import { Controller } from "@hotwired/stimulus"

/* Reveals a floating CTA while its section is on screen and hides it again on
 * the way out. The negative rootMargin keeps the pill from flashing in when
 * only a sliver of the section is visible at the edge of the viewport.
 */
export default class extends Controller {
  static targets = ["cta"]

  connect() {
    this._observer = new IntersectionObserver(
      (entries) => entries.forEach((entry) => this._toggle(entry.isIntersecting)),
      { threshold: 0.15, rootMargin: "-10% 0px -10% 0px" }
    )
    this._observer.observe(this.element)
  }

  disconnect() {
    if (this._observer) this._observer.disconnect()
  }

  _toggle(visible) {
    if (this.hasCtaTarget) this.ctaTarget.classList.toggle("is-visible", visible)
  }
}
